import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import LateOrdersDataGrid from 'components/reports/delivery/DeliveryPerformance/LateOrdersDataGrid';
import LateOrdersDayDataGrid from 'components/reports/delivery/DeliveryPerformance/LateOrdersDayDataGrid';
import LateDriversDataGrid from 'components/reports/delivery/DeliveryPerformance/LateDriversDataGrid';
import LateBreakdownDataGrid from 'components/reports/delivery/DeliveryPerformance/LateBreakdownDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
  dateFormat,
} from 'constant/Helpers';
import cloneDeep from 'lodash/cloneDeep';
import { getDeliveryPerformanceReportPageUrl } from 'constant/AppUrls';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// selector
import { getIsLoaderOpen } from 'store/app/AppSelectors';
// api
import DeliveryReportService from 'services/reportsService/DeliveryReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const DeliveryPerformanceReportPage = () => {
  const [data, setData] = useState([]);
  const isLoading = useSelector((state) => getIsLoaderOpen({ state }));
  const [breakdownData, setBreakdownData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: dateFormat(new Date()),
    toDate: dateFormat(new Date()),
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await DeliveryReportService.getDeliveryPerformance(params);
      const res2 = await DeliveryReportService.getDeliveryBreakdown(params);
      setData(res.data);
      setBreakdownData(res2.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Delivery Performance Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  const exportFile = async () => {
    dispatch(setLoaderOpenTrue());
    let params = inputValues;
    if (location.search) {
      params = convertQueryParamsIntoObject(location.search);
    }
    try {
      const res = await DeliveryReportService.exportDeliveryPerformance(params);
      toast.success(res?.data?.message);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Delivery Performance Report Page Export Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
      setInputValues(queryObj);
    } else {
      fetchData(inputValues);
    }
  }, []);

  const handleSubmit = async () => {
    const updatedParams = cloneDeep(inputValues);
    const queryString = convertObjectIntoQueryParams(updatedParams);
    navigate({
      pathname: getDeliveryPerformanceReportPageUrl(),
      search: queryString,
    });
    fetchData(updatedParams);
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        title="Delivery Performance"
        defaultDate
        handleExport={exportFile}
      />
      {!isLoading && (
        <>
          <LateOrdersDataGrid data={data.latePerformance} inputValues={inputValues} />
          <LateOrdersDayDataGrid data={data.lateDayPerformance} />
          <LateDriversDataGrid data={data.lateDriverPerformance} />
          <LateBreakdownDataGrid data={breakdownData} />
        </>
      )}
    </div>
  );
};

export default DeliveryPerformanceReportPage;
